import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.8641 18.55C12.7344 16.293 17 10.8227 17 7.75C17 4.02344 13.8646 1 10 1C6.13542 1 3 4.02344 3 7.75C3 10.8227 7.26562 16.293 9.13594 18.55C9.58437 19.0879 10.4156 19.0879 10.8641 18.55ZM10 5.5C10.6188 5.5 11.2123 5.73705 11.6499 6.15901C12.0875 6.58097 12.3333 7.15326 12.3333 7.75C12.3333 8.34674 12.0875 8.91903 11.6499 9.34099C11.2123 9.76295 10.6188 10 10 10C9.38116 10 8.78767 9.76295 8.35008 9.34099C7.9125 8.91903 7.66667 8.34674 7.66667 7.75C7.66667 7.15326 7.9125 6.58097 8.35008 6.15901C8.78767 5.73705 9.38116 5.5 10 5.5Z",
      fill: "#A1A1A1"
    }, null, -1)
  ])))
}
export default { render: render }